var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47731 6.73329L8.99903 8.25504L14.9785 2.27555C13.0739 0.562951 10.4716 -0.246702 7.91574 0.0659172C8.85307 2.20637 8.88499 5.08941 7.47731 6.73329Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7247 14.9802C16.711 13.8738 17.3973 12.5629 17.7422 11.1471C17.1216 10.876 16.4898 10.6802 15.8608 10.568C14.3361 10.2959 12.9938 10.5466 12.0188 11.2742L15.7247 14.9802Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2667 10.5227C12.9106 9.11494 15.7938 9.147 17.9341 10.0843C18.2466 7.52818 17.4372 4.92638 15.7245 3.02148L9.74501 9.00093L11.2667 10.5227Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5663 15.8635C10.6786 16.4925 10.8743 17.1243 11.1455 17.7449C12.5612 17.4001 13.8721 16.7137 14.9785 15.7274L11.2726 12.0215C10.5449 12.9965 10.2942 14.3388 10.5663 15.8635Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73215 7.48047C5.08827 8.88822 2.20506 8.85613 0.0647821 7.91887C0.0222473 8.27571 0.000347137 8.63726 0.000311852 9.00219C0.000347137 11.2293 0.80441 13.3326 2.27438 14.9816L8.25391 9.00222L6.73215 7.48047Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0811 17.9372C9.1438 15.7967 9.11185 12.9137 10.5195 11.2698L8.99778 9.74805L3.01833 15.7275C4.66734 17.1975 6.77063 18.0016 8.99778 18.0016C9.36274 18.0016 9.72429 17.9797 10.0811 17.9372Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27453 3.02148C1.28823 4.1279 0.601894 5.43881 0.25704 6.85454C2.02747 7.68585 4.56811 7.86503 5.98047 6.72743L2.27453 3.02148Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43202 2.13915C7.31978 1.51022 7.12404 0.87841 6.8529 0.257813C5.43714 0.602667 4.12627 1.289 3.01981 2.2753L6.72575 5.98124C7.45339 5.00619 7.70414 3.6639 7.43202 2.13915Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.ed6b749fcb1f24f6c3a6a6e459370cca.svg";
export { ForwardRef as ReactComponent };